import React from "react";

function BalancingProfit() {
  return (
    <div className="blockDivergent">
      <h2>Balancing profit with purpose. Spread trading reinvented.</h2>
      <ul className="author">
        <li>Charles Glah</li>
        <li class="sep">|</li>
        <li>Founder, Divergence Capital</li>
      </ul>
    </div>
  );
}

export default BalancingProfit;
